import {XAxisFormatValues} from '../../../generated/graphql';

export function isDatetimeAxisFormat(
  xAxis: string,
  xAxisFormat: XAxisFormatValues | undefined
) {
  if (
    xAxis === '_timestamp' ||
    xAxis === 'Wall Time' ||
    xAxisFormat === XAxisFormatValues.Datetime
  ) {
    return true;
  }
  return false;
}
